/**
 * API configuration with environment-specific URL handling 
 */

// Get the base URL from environment variables with appropriate defaults
// This will be automatically set by Vite based on environment
const isDev = import.meta.env.DEV;
export const API_BASE_URL = import.meta.env.VITE_API_URL || (isDev 
  ? 'http://localhost:8000'     // Development fallback
  : 'https://api.reasonic.ai'); // Production fallback

// Auth endpoints
export const AUTH_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/auth/login`,
  CHECK_TOKEN: `${API_BASE_URL}/auth/check-token`,
  REFRESH_TOKEN: `${API_BASE_URL}/auth/refresh-token`,
};

// User endpoints
export const USER_ENDPOINTS = {
  PROFILE: `${API_BASE_URL}/user/profile`,
  UPDATE_PROFILE: `${API_BASE_URL}/user/profile`,
};

// Campaign endpoints
export const CAMPAIGN_ENDPOINTS = {
  LIST: `${API_BASE_URL}/campaigns`,
  DETAIL: (id: string) => `${API_BASE_URL}/campaigns/${id}`,
  CREATE: `${API_BASE_URL}/campaigns`,
  UPDATE: (id: string) => `${API_BASE_URL}/campaigns/${id}`,
  DELETE: (id: string) => `${API_BASE_URL}/campaigns/${id}`,
};

// Publisher endpoints
export const PUBLISHER_ENDPOINTS = {
  DASHBOARD: `${API_BASE_URL}/publishers/dashboard`,
};

// Analytics endpoints
export const ANALYTICS_ENDPOINTS = {
  IMPRESSION: `${API_BASE_URL}/analytics/impression`,
  CLICK: `${API_BASE_URL}/analytics/click`,
};

// Playground endpoints
export const PLAYGROUND_ENDPOINTS = {
  SET_ROLE: `${API_BASE_URL}/playground/role`,
  GENERATE_ADS: `${API_BASE_URL}/playground/advertiser/generate`,
  PREVIEW_SDK: `${API_BASE_URL}/playground/publisher/preview`,
  GET_ANALYTICS: (role: string) => `${API_BASE_URL}/playground/analytics/${role}`,
  AD_PRESETS: `${API_BASE_URL}/playground/advertiser/presets`,
  GET_FRAMEWORKS: `${API_BASE_URL}/playground/publisher/frameworks`,
  GET_PLACEMENTS: `${API_BASE_URL}/playground/publisher/placements`,
};

// Console log the API base URL during development
if (import.meta.env.DEV) {
  console.log(`API configured with base URL: ${API_BASE_URL}`);
}

export default {
  API_BASE_URL,
  AUTH_ENDPOINTS,
  USER_ENDPOINTS,
  CAMPAIGN_ENDPOINTS,
  PUBLISHER_ENDPOINTS,
  ANALYTICS_ENDPOINTS,
  PLAYGROUND_ENDPOINTS,
}; 